'use client'

import { memo } from 'react'
import { UserRound } from 'lucide-react'
import { BaseNode } from './BaseNode'
import type { OperatorData } from '@/lib/pbx/flow/types'

interface OperatorNodeProps {
  data: OperatorData & { label?: string }
  selected?: boolean
}

function OperatorNodeComponent({ data, selected }: OperatorNodeProps) {
  const phoneCount = data?.phone_numbers?.length || 0

  return (
    <BaseNode
      icon={<UserRound className="w-4 h-4" />}
      label="Operator"
      selected={selected}
      outputHandles={[
        { id: 'answered', label: 'Answered', type: 'answered' },
        { id: 'no_answer', label: 'No Answer', type: 'no_answer' },
        { id: 'busy', label: 'Busy', type: 'busy' },
        { id: 'failed', label: 'Failed', type: 'failed' },
      ]}
      className="border-blue-500/50 bg-blue-50/50 dark:bg-blue-950/20"
    >
      <div className="space-y-1">
        {data?.operator_group_id ? (
          <p className="text-xs text-muted-foreground">
            Using group
          </p>
        ) : phoneCount > 0 ? (
          <p className="text-xs text-muted-foreground">
            {phoneCount} <span>direct</span> <span>{phoneCount === 1 ? 'number' : 'numbers'}</span>
          </p>
        ) : (
          <p className="text-xs text-yellow-600">No numbers configured</p>
        )}
        <p className="text-xs text-muted-foreground">
          <span>{data?.simulring ? 'Simultaneous' : 'Sequential'}</span> <span>•</span> {data?.timeout || 30}<span>s</span>
        </p>
      </div>
    </BaseNode>
  )
}

export const OperatorNode = memo(OperatorNodeComponent)
